import './contact-block.scss';

export default () => {
	$( '.js-smooth-scroll' ).click( function () {
		if ( location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
			let target = $( this.hash );

			target = target.length ? target : $( `[name=${this.hash.slice( 1 )}]` );
			if ( target.length ) {
				$( 'html,body' ).animate( {
					scrollTop: target.offset().top - 70,
				}, 1000 ); // The number here represents the speed of the scroll in milliseconds

				return false;
			}
		}
	} );
};
